import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { Observable, Subject, Subscription, catchError, debounceTime, distinctUntilChanged, finalize, map, of, skip, switchMap, tap } from 'rxjs';
import { DialogService } from 'src/app/services/dialog.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { ProiecteService } from './proiecte.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { FormControl, FormGroup } from '@angular/forms';
import { MatCalendar } from '@angular/material/datepicker';
import { Generic, GenericStatusProiecte } from 'src/app/interfaces/generic.interface';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { CommonService } from 'src/app/services/common.service';
import Swal from 'sweetalert2';
import { AddProiecteComponent } from './add-proiecte/add-proiecte.component';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { StatusuriProiecteService } from '../setari-proiecte/statusuri-proiecte/statusuri-proiecte.service';
import { DetaliiProiecteComponent } from './detalii-proiecte/detalii-proiecte.component';
import { IProiectListDT } from './proiecte.interface';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
    selector: 'app-proiecte',
    templateUrl: './proiecte.component.html',
    styleUrls: ['./proiecte.component.scss']
})
export class ProiecteComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    @ViewChild(PopoverDirective) popover!: PopoverDirective;

    helper = helper;
    isLoading = false;
    isFilterLoading = false;
    showCard = false;
    selectedArhivaID = 0;

    searchedTags: Generic[] = [];
    tagChangesSubscription = new Subscription();
    statusuriActive!: GenericStatusProiecte[];
    statusuriFiltered!: GenericStatusProiecte[];
    sectiuni!: Generic[];
    directiiActive!: Generic[];
    responsabili!: Generic[];
    operatori!: Generic[];

    categoriiActive$!: Observable<Generic[]>;
    furnizoriActive$!: Observable<Generic[]>;
    compartimenteActive$!: Observable<Generic[]>;

    // Popover dates
    @ViewChild('startCalendar') startCalendar!: MatCalendar<Date>;
    @ViewChild('endCalendar') endCalendar!: MatCalendar<Date>;

    today: Date = new Date();
    tomorrow: Date = new Date();
    selectedStartDate: Date = new Date(new Date().getFullYear(), 0, 1);
    private _selectedEndDate: Date = new Date();
    selectedFilteringButton: string = 'current_year';
    maxDate: Date | null = this.today;

    setLastXDays(numberOfDays: number): void {
        const date = new Date();
        date.setDate(this.today.getDate() - numberOfDays);
        this.selectedStartDate = date;
        this.updateCalendarView(this.startCalendar, date);
        this.rerenderDT();
        this.selectedFilteringButton = `last_${numberOfDays}_days`;
    }

    setYear(yearsBack: number): void {
        const year = this.today.getFullYear() - yearsBack;
        this.selectedStartDate = new Date(year, 0, 1); // 1 Ianuarie
        this.updateCalendarView(this.startCalendar, this.selectedStartDate);
        this.rerenderDT();
        this.selectedFilteringButton =
            yearsBack === 0 ? 'current_year' : 'previous_year';
    }

    updateCalendarView(calendar: MatCalendar<Date>, date: Date): void {
        if (calendar) {
            calendar.activeDate = date;
        }
    }

    // Methods used to dinamically select the start date according to the end date

    get selectedEndDate(): Date {
        return this._selectedEndDate;
    }

    set selectedEndDate(date: Date) {
        this._selectedEndDate = date;
        if (this.selectedStartDate > date) {
            this.selectedStartDate = new Date(date);
        }
    }

    // Date popover filtering

    dateFilteringOptions: { id: number; value: string }[] = [
        { id: 1, value: 'Data creării' },
        { id: 2, value: 'Data actualizării' },
        { id: 3, value: 'Data inițială a începerii' },
        { id: 4, value: 'Data reală a începerii' },
        { id: 5, value: 'Data inițiala a finalizării' },
        { id: 6, value: 'Data reală a finalizării' },
    ];

    dateFilterOption: number = 1;

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    // Values for filtering
    // statusParametersValue!: string;
    // categoryParametersValue!: string;
    notificationParameter: { id: string; name: string } = { id: '-1', name: '' };
    notificationServiceBefore: any = {
        currentStatus: -1,
        currentCategory: -1,
    }

    defaultParameter: { name: string; id: number } = {
        name: 'Toate',
        id: -1,
    };

    // Value for status filtering
    selectedStatusID: number = this.defaultParameter.id;

    // Values for category filtering
    categoryToggleOptions = [
        { id: -1, value: 'Toate' },
        { id: 1, value: 'Departamentele mele' },
        { id: 2, value: 'Proiectele mele' },
        { id: 3, value: 'Mesaje interne' },
    ];

    selectedCategoryID: number = this.categoryToggleOptions[0].id;

    provider_type: { key: string; value: number }[] = [
        { key: 'Toate', value: -1 },
        { key: 'Firmă', value: 1 },
        { key: 'Instituție Publică (Regie Propie)', value: 2 },
        { key: 'Firmă și Instituție Publică', value: 3 },
    ];

    project_type: { key: string; value: number }[] = [
        { key: 'Toate', value: -1 },
        { key: 'Mic', value: 1 },
        { key: 'Mare', value: 2 },
    ];

    searchParamsForm!: FormGroup;

    // Form initial values for filtering
    initialFormValues = {
        id_proiect: '',
        scale: -1,
        id_sectiune: -1,
        id_categorie: -1,
        id_directie: -1,
        id_compartiment: -1,
        id_responsible: -1,
        id_operator_teren: -1,
        name_tag: '',
        id_tag: '',
        provider_type: -1,
        id_provider: -1,
    };

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            id_proiect: new FormControl(''),
            scale: new FormControl(-1),
            id_sectiune: new FormControl(-1),
            id_categorie: new FormControl(-1),
            id_directie: new FormControl(-1),
            id_compartiment: new FormControl(-1),
            id_responsible: new FormControl(-1),
            id_operator_teren: new FormControl(-1),
            name_tag: new FormControl(''),
            id_tag: new FormControl(''),
            provider_type: new FormControl(-1),
            id_provider: new FormControl(-1),
        });
    }

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValues);

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.showCard = false;
        this.rerenderDT(true);
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }
    closeCard() {
        this.showCard = false;
    }

    closePopover(): void {
        if (this.popover) {
            this.popover.hide();
        }
    }

    toggleArhiva() {
        this.selectedArhivaID = this.selectedArhivaID === 0 ? 1 : 0;
        this.selectedStatusID = this.defaultParameter.id;
        this.filterStatusuriActive(this.statusuriActive, this.selectedArhivaID);

        this.rerenderDT();
    }

    onDateFilterChange(): void {
        this.maxDate = this.dateFilterOption == 1 || this.dateFilterOption == 2 ? this.today : null;
        if (this.maxDate && this.selectedEndDate > this.maxDate) {
            this.selectedEndDate = this.today;
        }

        this.rerenderDT();
    }

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink =
        environment.interop.basePath +
        environment.interop.monitoring.proiecte.listDTProiecte;

    constructor(
        private dialogService: DialogService,
        private http: HttpClient,
        private dialog: MatDialog,
        private proiecteService: ProiecteService,
        private commonService: CommonService,
        private statusuriProiecteService: StatusuriProiecteService,
        private notificationService: NotificationService,
        public permissionsService: PermissionsService,
    ) { }

    ngOnInit(): void {
        this.renderDT();
        this.buildSearchParamsForm();

        this.loadStatusuriActive();
        this.loadSectiuniProiecte();
        this.loadDirectiiActive();
        this.loadResponsabili();
        this.loadOperatori();
        this.renderTagSearch();
        this.filterCategoryOptions();
        this.redirectFromNotifications();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
        this.tagChangesSubscription.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            searching: false,
            responsive: true,
            pageLength: 25,
            order: [[0, 'desc']],

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;

                dataTablesParameters.id_arhiva = this.selectedArhivaID;
                dataTablesParameters.id_status = this.selectedStatusID;
                dataTablesParameters.id_choice = this.selectedCategoryID;
                Object.assign(dataTablesParameters, this.searchParamsForm.value);

                dataTablesParameters.date_type = this.dateFilterOption;
                dataTablesParameters.date_from = this.formatDate(
                    this.selectedStartDate
                );
                dataTablesParameters.date_to = this.formatDate(this.selectedEndDate);
                dataTablesParameters.notificationParameter = this.notificationParameter.id;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columnDefs: [
                { width: '100px', targets: [0] },
            ],
            columns: [
                {
                    title: 'ID',
                    data: 'id_proiect',
                    render: (data: any, type: any, row: any) => {
                        let flagIcon = '<i class="fa-solid fa-flag" style="color: white;"></i> ';

                        let source = '';
                        let color = '';
                        switch (row.source) {
                            case 1:
                                source = 'WEB';
                                color = '#06b706';
                                break;
                            default:
                                source = '';
                                break;
                        }
                        return `
                        <div style="display: flex; flex-direction: row; gap: 5px;">
                            <span>${row.id_proiect}</span>
                            <span style="color: ${color}; font-weight: 700;">${source}</span>
                        </div>
                        <br/>
                        ` + (row.mesajeInterne === 1 ?
                                `<div style="display:inline-block; padding: 4px 6px; color: white; background-color: red; border: 0px;border-radius:10px">
                                    <span>${flagIcon} Mesaj intern</span>
                                </div>`
                                : '')
                            + `
                        `;
                    },
                },
                {
                    title: 'Proiect',
                    data: 'subject',
                    render: (data: any, type: any, row: any) => {
                        const imageUrl = '/assets/icons/icon-addcard.svg';
                        const imageTreeUrl = '/assets/icons/icon-tree.svg';

                        return `
                            <span class="pointer"><b>${row.subject}</b></span>
                            <br/>
                            ${row.tag_name ?
                                `
                                <small style='color: #888'>
                                    <span>
                                        <i class='fa fa-tag'></i>
                                        ${row.tag_name}
                                    </span>
                                </small>
                                `   :
                                ""
                            }
                            <br/>
                            <span style="color:#bdbdbd; font-size:12px"> Categorie / Tip</span><br/>
							<span>
							<img src="${imageUrl}" alt="Image" style="width: 20px; height: 20px;">
							${row.directie_name}<br/>
							<img src="${imageTreeUrl}" alt="Image" style="width: 20px; height: 20px;">
							${row.compartiment_name}</span>
                        `;
                    },
                },
                // {
                //     title: 'Atribuire',
                //     data: null,
                //     sortable: false,

                //     render: (data: any, type: any, row: any) => {
                //         const imageUrl = '/assets/icons/icon-addcard.svg';
                //         const imageTreeUrl = '/assets/icons/icon-tree.svg';

                //         return `
                //             <span style="color:#bdbdbd; font-size:12px">Locație Solicitare</span><br/>
                //             <span style="color:#bdbdbd; font-size:12px">Secțiune</span><br/>
                //             <span style="font-weight:600 font-size:16px">${row.section_name}</span><br/>
                //             <span style="color:#bdbdbd; font-size:12px">Categorie</span><br/>
                //             <span style="font-weight:600 font-size:16px">${row.categorie_name}</span><br/>
                //         `;
                //     }
                // },
                {
                    title: 'Categorie',
                    data: 'categorie_name',
                },
                {
                    title: 'Secțiune',
                    data: 'section_name',
                },
                {
                    title: 'Tip',
                    data: 'scale',
                    render: (data: any, type: any, row: any) => {
                        return `
                                <span class='little-label' style='color: #ffffff; background-color:${row.scale_color_code}'>
                                   ${row.scale}
                                </span>
                            `
                    }

                },
                {
                    title: 'Nr. Resp.',
                    data: 'operatori',
                    render: (data: any, type: any, row: any) => {
                        return `
                                <i class='fa-solid fa-user-group'></i> ${row.operatori}
                            `
                    }
                },
                {
                    title: 'Responsabil',
                    data: 'user_assigned_name',
                },
                {
                    title: 'Status',
                    data: 'status_name',
                    render: (data: any, type: any, row: any) => {
                        return `
                                <span class='little-label' style='color: #ffffff; background-color:${row.status_color}'>
                                   ${row.status_name}
                                </span>
                            `
                    }
                },
                {
                    title: 'Arhivat',
                    data: 'arhiva',
                    render: (data: any, type: any, row: any) => {
                        const arhivat = row.arhiva ? 'Arhivat' : 'Nearhivat';
                        return `${arhivat} `;
                    },
                },
                {
                    title: 'Inceput',
                    data: 'data_inceput_reala',
                    render: (data: any, type: any, row: any) => {
                        const month = row.data_inceput_reala.substring(5, 7);
                        const day = row.data_inceput_reala.substring(8, 10);
                        const year = row.data_inceput_reala.substring(0, 4);
                        const initialDate = new Date(row.data_inceput_init);
                        const realDate = new Date(row.data_inceput_reala);
                        // const currentDate = new Date();
                        // const offsetMinutes = -currentDate.getTimezoneOffset();
                        // currentDate.setHours(0, offsetMinutes, 0, 0);

                        return `
                            <div class='calendar-group second-calendar'>		
                                <span class='month-label'>${this.createMonthLabel(month)}</span>		
                                <span class='day-label'>${day}</span>	
                                <span class='year-label'>${year}</span>
                            </div>
                            ${row.delay_inceput ?
                                `
                                <div class='d-flex flex-column gap-1'>
                                    <strong>
                                        <span class="red-text"><i class="fa fa-clock"></i>${this.differenceInDays(realDate, initialDate)} zile</span>
                                    </strong>
                                </div>
                                `   :
                                ""
                            }
                        `
                    }
                },
                {
                    title: 'Finalizare',
                    data: 'data_finalizare_reala',
                    render: (data: any, type: any, row: any) => {
                        const month = row.data_finalizare_reala.substring(5, 7);
                        const day = row.data_finalizare_reala.substring(8, 10);
                        const year = row.data_finalizare_reala.substring(0, 4);
                        const initialDate = new Date(row.data_finalizare_init);
                        const realDate = new Date(row.data_finalizare_reala);
                        // const currentDate = new Date();
                        // const offsetMinutes = -currentDate.getTimezoneOffset();
                        // currentDate.setHours(0, offsetMinutes, 0, 0);

                        return `
                            <div class='calendar-group second-calendar'>		
                                <span class='month-label'>${this.createMonthLabel(month)}</span>			
                                <span class='day-label'>${day}</span>
                                <span class='year-label'>${year}</span>
                            </div>
                            ${row.delay_final ?
                                `
                                <div class='d-flex flex-column gap-1'>
                                    <strong>
                                        <span class="red-text"><i class="fa fa-clock"></i>${this.differenceInDays(realDate, initialDate)} zile</span>
                                    </strong>
                                </div>
                                `   :
                                ""
                            }
                        `
                    }
                },
                {
                    title: 'Actualizat',
                    data: 'updated_at',
                    render: (data: any, type: any, row: any) => {
                        return `${row.updated_at.replace("T", " ").slice(0, -8)}`
                    }
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                $('td', row).off('click');

                $('td:not(:first-child)', row).on('click', () => {
                    this.onRowClick(data);
                });

                return row;
            },
        };
    }

    rerenderDT(resetPaging = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(resetPaging);
        });
        this.showCard = false;
    }

    createMonthLabel(month: string): string {
        let monthLabel = '';
        switch (month) {
            case '01':
                monthLabel = 'IAN';
                break;
            case '02':
                monthLabel = 'FEB';
                break;
            case '03':
                monthLabel = 'MAR';
                break;
            case '04':
                monthLabel = 'APR';
                break;
            case '05':
                monthLabel = 'MAI';
                break;
            case '06':
                monthLabel = 'IUN';
                break;
            case '07':
                monthLabel = 'IUL';
                break;
            case '08':
                monthLabel = 'AUG';
                break;
            case '09':
                monthLabel = 'SEP';
                break;
            case '10':
                monthLabel = 'OCT';
                break;
            case '11':
                monthLabel = 'NOI';
                break;
            case '12':
                monthLabel = 'DEC';
                break;
            default:
                monthLabel = '';
                break;
        }
        return monthLabel;
    }

    differenceInDays(date1: Date, date2: Date) {
        // Convert both dates to milliseconds
        const date1Ms = date1.getTime();
        const date2Ms = date2.getTime();

        // Calculate the difference in milliseconds
        const differenceMs = Math.abs(date1Ms - date2Ms);

        // Convert milliseconds to days
        const millisecondsPerDay = 1000 * 60 * 60 * 24;
        const differenceDays = Math.floor(differenceMs / millisecondsPerDay);

        if (date1Ms < date2Ms) {
            return -differenceDays;
        }
        return differenceDays;
    }

    openAddDialog() {
        this.closeCard();
        this.closePopover();

        const dialogRef = this.dialog.open(AddProiecteComponent, {
            minWidth: 800,
            maxWidth: 1000,
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Proiect adăugat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    onRowClick(rowData: IProiectListDT) {
        this.openInfoDialog(rowData);
    }

    openInfoDialog(data: IProiectListDT) {
        this.closeCard();
        this.closePopover();

        const dialogRef = this.dialog.open(DetaliiProiecteComponent, {
            minHeight: '100vh',
            maxHeight: '100vh',
            minWidth: '100vw',
            maxWidth: '100vw',
            disableClose: true,
            data: {
                proiectData: data,
            },
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            this.rerenderDT();
        });
    }

    loadSectiuniProiecte() {
        this.isFilterLoading = true;
        this.commonService.getSectiuniProiecte().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isFilterLoading = false))
        ).subscribe({
            next: (results) => {
                this.sectiuni = results;
            },
            error: (error) => {
                console.error('Error loading sectiuni', error);
                this.isFilterLoading = false;
            },
        });
    }

    onSectiuneChange(sectiuneId: number): void {
        if (sectiuneId > 0) {
            this.loadCategoriiActive(sectiuneId);
        } else {
            this.categoriiActive$ = new Observable<Generic[]>((observer) => {
                observer.next([{ name: 'Toate', id: -1 }]);
                observer.complete();
            });
        }
    }

    loadCategoriiActive(sectiuneId?: number) {
        this.isFilterLoading = true;
        let categoriiObservable$ = sectiuneId
            ? this.commonService.filterCategoriiProiecte(sectiuneId)
            : this.commonService.getCategoriiProiecte();

        this.categoriiActive$ = categoriiObservable$.pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => {
                this.isFilterLoading = false;
            })
        );
    }

    loadDirectiiActive() {
        this.isFilterLoading = true;

        this.commonService.getDirectiiActive().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isFilterLoading = false))
        ).subscribe({
            next: (results) => {
                this.directiiActive = results;
            },
            error: (error) => {
                console.error('Error loading directii', error);
            },
        });;
    }

    onDirectieChange(directieId: number): void {
        if (directieId > 0) {
            this.loadCompartimenteActive(directieId);
        } else {
            this.compartimenteActive$ = new Observable<Generic[]>((observer) => {
                observer.next([{ name: 'Toate', id: -1 }]);
                observer.complete();
            });
        }
    }

    loadCompartimenteActive(directieId?: number) {
        this.isFilterLoading = true;
        let compartimenteObservable$ = directieId
            ? this.commonService.getCompartimenteByDirectie(directieId)
            : this.commonService.getCompartimenteActive();

        this.compartimenteActive$ = compartimenteObservable$.pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => {
                this.isFilterLoading = false;
            })
        );
    }

    loadResponsabili() {
        this.isFilterLoading = true;
        this.proiecteService.getResponsabili().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isFilterLoading = false))
        ).subscribe({
            next: (results) => {
                this.responsabili = results;
            },
            error: (error) => {
                console.error('Error loading responsabili', error);
                this.isFilterLoading = false;
            },
        });
    }

    loadOperatori() {
        this.isFilterLoading = true;
        this.proiecteService.getOperatori().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isFilterLoading = false))
        ).subscribe({
            next: (results) => {
                this.operatori = results;
            },
            error: (error) => {
                console.error('Error loading operatori', error);
                this.isFilterLoading = false;
            },
        });
    }

    onTipFurnizoriChange(provider_type: number): void {
        if (provider_type > 0) {
            this.loadFurnizoriActive(provider_type);
        } else {
            this.furnizoriActive$ = new Observable<Generic[]>((observer) => {
                observer.next([{ name: 'Toate', id: -1 }]);
                observer.complete();
            });
        }
    }

    loadFurnizoriActive(provider_type?: number) {
        this.isFilterLoading = true;
        let furnizoriObservable$ = provider_type ?
            this.commonService.filterProviderProiecte(provider_type) :
            this.commonService.getProviderProiecte()

        this.furnizoriActive$ = furnizoriObservable$.pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => {
                this.isFilterLoading = false;
            })
        );
    }

    loadStatusuriActive() {
        this.isFilterLoading = true;
        this.statusuriProiecteService
            .getStatusuriAllActive()
            .pipe(
                map((results: any) => [...results, this.defaultParameter]),
                finalize(() => (this.isFilterLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.statusuriActive = results;
                    this.filterStatusuriActive(this.statusuriActive, this.selectedArhivaID);
                },
                error: (error) => {
                    console.error('Error loading request statuses', error);
                    this.isFilterLoading = false;
                },
            });
    }

    filterStatusuriActive(statusuri: GenericStatusProiecte[], arhiva: number) {
        this.statusuriFiltered = statusuri.filter(status => {
            return (status.arhiva === arhiva || status.name === "Toate")
        })
    }

    onStatusChange(event: MatButtonToggleChange) {
        this.isLoading = true;
        this.selectedStatusID = event.value;

        // this.statusParametersValue = event.value === 'toate' ? '-1' : '1';
        this.rerenderDT();
    }

    onCategoryChange(event: MatButtonToggleChange) {
        this.isLoading = true;
        this.selectedCategoryID = event.value;

        // const selectedOption = this.categoryToggleOptions.find(option => option.id === event.value);
        // this.categoryParametersValue = selectedOption ? selectedOption.value : 'default';
        this.rerenderDT();
    }

    filterCategoryOptions() {
        const permissionMapping: { [key: string]: string } = {
            "-1": "monitoring-module.proiecte.proiecte-view.list-all",
            "1": "monitoring-module.proiecte.proiecte-view.list-my-departments",
            "2": "monitoring-module.proiecte.proiecte-view.list-my-projects",
            "3": "monitoring-module.proiecte.proiecte-view.list-intern-messages",
        };

        // Filter categoryToggleOptions based on permissions
        this.categoryToggleOptions = this.categoryToggleOptions.filter(option =>
            this.permissionsService.hasPermission(permissionMapping[option.id.toString()])
        );

        // Initialize selectedCategory after filtering
        this.selectedCategoryID = this.categoryToggleOptions[0]?.id;
    }

    renderTagSearch() {
        this.tagChangesSubscription = this.searchParamsForm
            .controls['name_tag'].valueChanges.pipe(
                skip(1), // Ignore the first emitted value
                debounceTime(500),
                distinctUntilChanged(),
                switchMap((tagValue) => {
                    // Reset Tag ID before search
                    this.searchParamsForm.controls['id_tag'].setValue('');

                    this.isFilterLoading = true;
                    return this.commonService.typeheadTagProiecte({ name: tagValue });
                }),
                tap((data: Generic[]) => {
                    this.isFilterLoading = false;
                    this.searchedTags = data;
                }),
                catchError(() => of([]))
            )
            .subscribe();
    }

    onTagSelected(option: { id: number; name: string }) {
        // Unsubscribe from valueChanges to avoid an unnecessary call to the BE when setting a value
        this.tagChangesSubscription.unsubscribe();

        this.searchParamsForm.controls['name_tag'].setValue(option.name);
        this.searchParamsForm.controls['id_tag'].setValue(option.id);

        // Resubscribe to valueChanges after setting the value
        this.renderTagSearch();
    }

    redirectFromNotifications() {
        this.notificationService.currentNotification.subscribe(
            (notification: { id: string; name: string }) => {
                if (notification) {
                    this.notificationParameter = notification;
                    // here we need to update our buttons
                    this.notificationServiceBefore.currentStatus = this.selectedStatusID;
                    this.notificationServiceBefore.currentCategory = this.selectedCategoryID;

                    this.selectedStatusID = -1;
                    this.selectedCategoryID = -1;

                    this.rerenderDT();
                }
            }
        );
    }

    removeChip(): void {
        // Resets the notification parameter which we send to our backend with -1 so the filter for this particular flag is canceled
        this.notificationParameter = { id: '-1', name: '' };

        // here we need to update our buttons
        this.selectedStatusID = this.notificationServiceBefore.currentStatus;
        this.selectedCategoryID = this.notificationServiceBefore.currentCategory;

        this.rerenderDT();
    }
}
